import { CombinedGraphQLErrors } from '@apollo/client'

export type GraphqlErrorClassification = 'unauthenticated' | 'forbidden' | 'bad-user-input' | 'unexpected'

// 画面側のエラー表示分岐（ログインし直す／このテナントにはアクセスできない等）に使う。
// サーバー側（Apollo Server）の extensions.code に合わせて分類する
export function classifyGraphqlError(error: unknown): GraphqlErrorClassification {
  if (!CombinedGraphQLErrors.is(error)) {
    return 'unexpected'
  }

  const codes = error.errors.map((graphQLError) => graphQLError.extensions?.code)
  if (codes.includes('UNAUTHENTICATED')) {
    return 'unauthenticated'
  }
  if (codes.includes('FORBIDDEN')) {
    return 'forbidden'
  }
  if (codes.includes('BAD_USER_INPUT')) {
    return 'bad-user-input'
  }
  return 'unexpected'
}
